import { ImageViewerModal } from "@common/camera/CameraImagesM"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import FilledButtonM from "@common/components/button/FilledButtonM"
import IconButtonM from "@common/components/button/IconButtonM"
import { Menu3Point } from "@common/components/menu/Menu3Point"
import TextM from "@common/components/text/TextM"
import TitleM from "@common/components/text/TitleM"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    addPhoneRinging,
    removePhoneRinging,
    resetPhoneRinging,
    setCallPortal,
    setPhoneRinging,
} from "@data/redux/actions/liveMode"
import { activitiesService } from "@data/services/activitiesService"
import { liveService } from "@data/services/liveService"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import { hasRole } from "@data/utility/ability"
import { displayTimeSeconds } from "@data/utility/Utils"
import { useNavigation } from "@react-navigation/native"
import moment from "moment/moment"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Dimensions, FlatList, View } from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import { ActivityIndicator, IconButton } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"
import NewStudentsListItem from "../../tutor/students/NewStudentsListItem"
import GenerateActivityModal from "../../tutor/students/GenerateActivityModal"

export const TIME_SINCE_LAST_CALL_MINUTES = 10
const StudentsList = (props) => {
    const flatListRef = useRef()
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const [showGenerateActivityModal, setShowGenerateActivityModal] = useState(false)

    const byChapter = !props.isLive
    const liveSession = props.currentLiveSession
    const closestNextOccurrence = findClosestNextOccurrence([liveSession])
    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null

    const isIndividual = liveSession?.live_room?.type === "individual"
    const studentParticipants =
        liveSession?.users?.filter((user) => !user?.is_tutor) ?? []

    const didAnyStudentConnect =
        props.todayLiveSessionLogs?.filter(
            (log) =>
                log?.action === "get_live_session" &&
                studentParticipants
                    ?.map((c) => c?.id)
                    ?.includes(log?.user_id) &&
                moment(log?.created_at)?.isSameOrAfter(
                    liveMoment.clone().subtract(15, "minutes")
                )
        )?.length > 0

    const presentStudents =
        studentParticipants?.filter((user) =>
            props.participants?.includes(user?.id)
        ) ?? []

    const setSoundModeApiRequest = liveServiceV2.setSoundModeV2
    const lowerHandsApi = liveServiceV2.lowerHandsV2

    const getLiveSessionApi = liveServiceV2.getLiveSessionV2
    const getCallApi = liveServiceV2.getCallV2

    useEffect(() => {
        setTimeout(() => {
            props.setCallPortal(true)
        }, 1000)
    }, [])

    const request =
        props.getSessionsRequest ||
        props.getCallRequest ||
        props.deleteCommonActivityTodoRequest ||
        props.getSessionV2Request ||
        props.getCallV2Request

    const { sendLiveKitData: sendNewTodo } = useLiveKitEventSender()

    useApiStatus(
        liveService.makeCall, // api service
        false, // success message on toast (string or null)
        false, // error message on toast (true) or keep it in redux state (false)
        () => {
            if (navigation.canGoBack()) navigation.popToTop()
            SnackBarM.show({ text1: "Appel en cours...", duration: 4000 })
        } // success callback
    )
    useApiStatus(
        liveService.lowerAllHands, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {} // success callback
    )

    useApiStatus(
        lowerHandsApi, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {} // success callback
    )

    useApiStatus(
        setSoundModeApiRequest, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
            // console.log("setSoundMode", successData)
        } // success callback
    )

    useApiStatus(
        activitiesService.deleteCommonActivityTodo, // api service
        false, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        (successData) => {
            successData?.students_ids?.forEach((id) => {
                sendNewTodo(
                    "newTodo",
                    {
                        id,
                    },
                    [id]
                )
            })

            DialogM.show({
                text1: "Effectué",
                text2: successData?.message,
            })
        } // success callback
    )

    useEffect(() => {
        props.resetPhoneRinging()
    }, [])

    const additionalActions = (item, isSoundOn, isOnline, activeTime) => {
        // First create all standard actions
        const actions = [
            {
                icon: "headset",
                backgroundColor: null,
                disabled: true,
                label: displayTimeSeconds(activeTime ?? 0),
                color: theme.colors.success,
                onPress: () => {},
            },
            {
                icon: "stopwatch",
                backgroundColor:
                    (props.timesSinceLastCall?.[item.item?.id] ?? 0) >=
                    TIME_SINCE_LAST_CALL_MINUTES * 60
                        ? theme.colors.errorLight
                        : null,
                disabled: true,
                label: displayTimeSeconds(
                    props.timesSinceLastCall?.[item.item?.id] ?? 0
                ),
                badgeCounter:
                    (props.timesSinceLastCall?.[item.item?.id] ?? 0) >=
                    TIME_SINCE_LAST_CALL_MINUTES * 60
                        ? 1
                        : 0,
                color:
                    (props.timesSinceLastCall?.[item.item?.id] ?? 0) >=
                    TIME_SINCE_LAST_CALL_MINUTES * 60
                        ? theme.colors.error
                        : theme.colors.purple,
                onPress: () => {},
            },
        ]

        // No concentré toggle for individual sessions — always dialogue
        if (!isIndividual) {
            actions.push({
                icon: !isSoundOn ? "volume-mute" : "volume-up",
                backgroundColor: !isOnline
                    ? theme.colors.lightMore
                    : !isSoundOn
                    ? theme.colors.purple
                    : theme.colors.success,
                label: !isOnline ? "-" : !isSoundOn ? "Silence" : "Dialogue",
                color: theme.colors.white,
                request:
                    (props.setSoundModeRequest &&
                        props.setSoundModeRequestUserIds?.includes(
                            item.item?.id
                        )) ||
                    (props.setSoundModeV2Request &&
                        props.setSoundModeV2RequestUserIds?.includes(
                            item.item?.id
                        )),
                disabled: !isOnline,
                fontSize: 10,
                borderRadius: 10,
                onPress: () => {
                    props.apiRequest(
                        setSoundModeApiRequest,
                        { id: props.liveSessionId },
                        {
                            enabled: !props.soundModeIds?.find(
                                (id) => id === item.item?.id
                            ),
                            user_ids: [item.item?.id],
                        }
                    )
                    props.apiRequest(
                        lowerHandsApi,
                        { id: props.liveSessionId },
                        { user_ids: [item.item?.id] }
                    )
                },
            })
        }

        return actions
    }
    const renderItem = (item) => {
        const isSoundOn = props.soundModeIds?.find((id) => id === item.item?.id)
        const isOutOfApp = props.outOfAppIds?.find((id) => id === item.item?.id)
        const isOnline = !!props.participants?.find((x) => x === item.item?.id)
        const activeTime =
            props.activeTime?.find((x) => x?.id === item.item?.id)?.time ?? 0
        const isActivityCameraOn = props.activityCameraOnIds?.find(
            (id) => id === item.item?.id
        )

        return (
            <NewStudentsListItem
                student={item.item}
                isTutor={item.item?.is_tutor}
                index={item.index}
                studentsNumber={studentParticipants.length}
                byChapter={byChapter}
                soundMode={isSoundOn && isOnline && !item.item?.is_tutor}
                isOutOfApp={isOutOfApp}
                style={{}}
                withTodo
                isActivityCameraOn={isActivityCameraOn}
                additionalActions={additionalActions(
                    item,
                    isSoundOn,
                    isOnline,
                    activeTime
                )}
                isLiveMode
            />
        )
    }
    const [openGoldenRules, setOpenGoldenRules] = React.useState(false)

    const isTrial = liveSession?.live_room?.type === "trial"

    const renderGoldenRules = () => (
        <>
            <FilledButtonM
                onPress={() => {
                    setOpenGoldenRules(true)
                }}
                icon={isTrial ? "mobile-alt" : "book-open"}
                style={{
                    marginBottom: 0,
                    maxWidth: 160,
                    marginRight: 10,
                    height: 30,
                }}
                contentStyle={{
                    marginBottom: 0,
                    maxWidth: 160,
                    height: 30,
                }}
                labelStyle={{
                    fontSize: 11,
                }}
                color={isTrial ? theme.colors.success : theme.colors.accent}
                label={isTrial ? "Tuto élève" : "5 règles d'or"}
            />
        </>
    )
    const renderHeader = () => {
        return (
            <>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent:
                            dimensions.width > 800 ? "center" : "flex-start",
                        width: Dimensions.get("window").width,
                        borderColor: theme.colors.lightMore,
                        paddingVertical: 8,
                        paddingHorizontal: 20,
                        marginBottom: dimensions.width > 800 ? 20 : 0,
                    }}
                >
                    {dimensions.width > 800 && (
                        <View
                            style={{
                                position: "absolute",
                                left: 40,
                                top: 5,
                                alignItems: "center",
                            }}
                        >
                            {renderFooter({
                                width: "100%",
                                justifyContent: "flex-start",
                            })}
                        </View>
                    )}
                    <ImageViewerModal
                        visible={openGoldenRules}
                        onDismiss={() => setOpenGoldenRules(false)}
                        imageIndex={0}
                        images={[
                            isTrial
                                ? "https://masteur.com/wp-content/uploads/2024/11/tuto-eleve-live-1-scaled.webp"
                                : "https://masteur.com/wp-content/uploads/2024/04/regles-dor-live-scaled.webp",
                        ]}
                    />
                    <TitleM fontWeight="ExtraBold">
                        {"élèves".toUpperCase()}
                    </TitleM>
                    <View
                        style={{
                            position: "absolute",
                            right: 20,
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        {dimensions.width > 800 ? renderGoldenRules() : null}
                        {dimensions.width > 800 ? (
                            <FilledButtonM
                                onPress={() => {
                                    navigation.push("new-todo", {
                                        forStudents: true,
                                    })
                                }}
                                icon={"plus"}
                                style={{
                                    marginBottom: 0,
                                    maxWidth: 150,
                                    height: 30,
                                    marginLeft: 5,
                                }}
                                contentStyle={{
                                    marginBottom: 0,
                                    maxWidth: 150,
                                    height: 30,
                                }}
                                labelStyle={{
                                    fontSize: 11,
                                }}
                                color={theme.colors.primary}
                                label={"Activité"}
                            />
                        ) : (
                            <IconButtonM
                                onPress={() => {
                                    navigation.push("new-todo", {
                                        forStudents: true,
                                    })
                                }}
                                icon={"plus"}
                                size={15}
                                style={{
                                    height: 30,
                                    width: 30,
                                    backgroundColor: theme.colors.primary,
                                    alignSelf: "center",
                                    borderRadius: 20,
                                }}
                                iconColor={theme.colors.white}
                            />
                        )}
                        {request && IS_WEB ? (
                            <ActivityIndicator
                                color={theme.colors.primary}
                                size={"small"}
                                style={{ marginRight: 6 }}
                            />
                        ) : (
                            <IconButton
                                onPress={() => {
                                    props.apiRequest(getLiveSessionApi, {
                                        id: props.liveSessionId,
                                    })
                                    props.apiRequest(getCallApi, {
                                        id: props.liveSessionId,
                                    })
                                }}
                                iconColor={theme.colors.primary}
                                containerColor={theme.colors.transparent}
                                disabled={request}
                                icon={"sync-alt"}
                                size={20}
                            />
                        )}
                        <Menu3Point
                            menuItems={[
                                ...(!isIndividual
                                    ? [
                                          {
                                              icon: "volume-mute",
                                              title: "Mettre tous en mode concentré",
                                              onPress: () => {
                                                  props.apiRequest(
                                                      setSoundModeApiRequest,
                                                      {
                                                          id: props.liveSessionId,
                                                      },
                                                      {
                                                          enabled: false,
                                                          user_ids:
                                                              studentParticipants?.map(
                                                                  (u) => u?.id
                                                              ),
                                                      }
                                                  )
                                              },
                                          },
                                          {
                                              icon: "volume-up",
                                              title: "Mettre tous en mode dialogue",
                                              onPress: () => {
                                                  props.apiRequest(
                                                      setSoundModeApiRequest,
                                                      {
                                                          id: props.liveSessionId,
                                                      },
                                                      {
                                                          enabled: true,
                                                          user_ids:
                                                              studentParticipants?.map(
                                                                  (u) => u?.id
                                                              ),
                                                      }
                                                  )
                                              },
                                          },
                                      ]
                                    : []),
                                {
                                    icon: "plus",
                                    title: "Nouvelle activité commune",
                                    onPress: () => {
                                        setShowGenerateActivityModal(true)
                                    },
                                },
                                {
                                    icon: "book-open",
                                    title: "Les 5 règles d'or",
                                    onPress: () => {
                                        setOpenGoldenRules(true)
                                    },
                                },
                            ]}
                            optionStyle={{
                                width: 200,
                            }}
                        />
                    </View>
                </View>
                {studentParticipants?.length > 0 &&
                    presentStudents?.length === 0 &&
                    !didAnyStudentConnect &&
                    liveSession?.live_room?.type !== "trial" &&
                    liveMoment?.isBefore(moment()?.subtract(3, "minutes")) && (
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent:
                                    dimensions.width > 800
                                        ? "center"
                                        : "flex-start",
                                width: Dimensions.get("window").width,
                                paddingVertical: 3,
                                paddingHorizontal: 20,
                                marginBottom: dimensions.width > 800 ? 10 : 0,
                            }}
                        >
                            <View
                                style={{
                                    width: "100%",
                                    padding: 10,
                                    backgroundColor: theme.colors.errorLight,
                                    borderRadius: 10,
                                }}
                            >
                                <TextM wrap>
                                    Aucun élève connecté pour le moment. Les
                                    parents sont notifiés automatiquement au
                                    bout de 5 minutes. Si tu n&apos;as aucune
                                    nouvelle au bout de 20 minutes, tu peux
                                    clôturer le live.
                                </TextM>
                            </View>
                        </View>
                    )}
            </>
        )
    }
    const renderFooter = (style = {}) => {
        return (
            <>
                {hasRole(props.user, "tutor") && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            width: Dimensions.get("window").width,
                            borderColor: theme.colors.lightMore,
                            paddingTop: 8,
                            paddingRight: 10,
                            ...style,
                        }}
                    >
                        <FontAwesome5
                            name="headset"
                            solid
                            size={16}
                            color={theme.colors.success}
                        />
                        <TextM wrap style={{ marginLeft: 5 }} fontSize={10}>
                            {" "}
                            = Temps total en mode dialogue
                        </TextM>
                    </View>
                )}
                {hasRole(props.user, "tutor") && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            width: Dimensions.get("window").width,
                            borderColor: theme.colors.lightMore,
                            paddingTop: 8,
                            paddingRight: 10,
                            ...style,
                        }}
                    >
                        <FontAwesome5
                            name="stopwatch"
                            solid
                            size={16}
                            color={theme.colors.purple}
                        />
                        <TextM wrap style={{ marginLeft: 5 }} fontSize={10}>
                            {" "}
                            = Temps écoulé de puis la dernière activation du
                            mode concentré
                        </TextM>
                    </View>
                )}
            </>
        )
    }

    const ITEM_WIDTH = Dimensions.get("window").width - 60
    const snapToOffsets = studentParticipants.map((x, i) => {
        return i * ITEM_WIDTH - 10
    })
    const renderFinalize = () => {
        return (
            <View
                style={{
                    alignSelf: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    marginVertical: 20,
                    width: "100%",
                }}
            >
                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{
                        position: "absolute",
                        left: 4,
                    }}
                    onPress={() => {
                        if (navigation.canGoBack()) navigation.goBack()
                        else navigation.replace("menu")
                    }}
                />
                <View
                    style={{
                        alignSelf: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "70%",
                    }}
                >
                    <TextM
                        wrap
                        color={theme.colors.primary}
                        fontWeight={"Bold"}
                        fontSize={17}
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Avant de clôturer, mets bien à jour la liste
                        d&apos;activités de chaque élève
                    </TextM>
                    <TextM
                        style={{
                            textAlign: "center",
                        }}
                        wrap
                        color={theme.colors.primary}
                        fontWeight={"SemiBold"}
                    >
                        Fais un peu de nettoyage pour que chaque élève sache ce
                        qu&apos;il doit faire avant la prochaine séance
                    </TextM>
                </View>
            </View>
        )
    }
    return (
        <View
            style={{
                flex: 1,
                backgroundColor: theme.colors.whiteAlmost,
                alignItems: "center",
                width: Dimensions.get("window").width,
                alignSelf: "center",
            }}
        >
            <>
                {props.finalizeMode ? renderFinalize() : <>{renderHeader()}</>}
                <FlatList
                    data={studentParticipants ?? []}
                    ref={flatListRef}
                    refreshing={
                        !!props.getSessionsRequest ||
                        !!props.getSessionV2Request
                    }
                    onRefresh={() => {
                        props.apiRequest(getLiveSessionApi, {
                            id: props.liveSessionId,
                        })
                        props.apiRequest(getCallApi, {
                            id: props.liveSessionId,
                        })
                    }}
                    style={{
                        width: Dimensions.get("window").width,
                    }}
                    horizontal
                    pagingEnabled={!IS_WEB}
                    decelerationRate={0}
                    snapToOffsets={snapToOffsets}
                    snapToAlignment={"center"}
                    ListEmptyComponent={() => (
                        <TextM style={{ textAlign: "center", marginTop: 0 }}>
                            Aucun participant
                        </TextM>
                    )}
                    renderItem={renderItem}
                />
            </>
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />

            {/* Generate Activity Modal for multi-student */}
            {showGenerateActivityModal && (
                <GenerateActivityModal
                    isOpen={showGenerateActivityModal}
                    onClose={() => setShowGenerateActivityModal(false)}
                    student={null}
                    schoolSubjects={props.schoolSubjects}
                    forStudents={true}
                    studentsList={studentParticipants}
                    nav={navigation}
                    isLiveMode={props.isLive}
                    liveSessionId={props.liveSessionId}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        raisedHands: state.liveMode?.raisedHands,
        soundModeIds: state.liveMode?.soundModeIds,
        outOfAppIds: state.liveMode?.outOfAppIds,
        activityCameraOnIds: state.liveMode?.activityCameraOnIds,
        phoneRinging: state.liveMode?.phoneRinging,
        timesSinceLastCall: state.liveMode?.timesSinceLastCall,
        activeTime: state.liveMode?.activeTime,
        participants: state.liveMode?.liveParticipants,
        schoolSubjects: state.data.staticData?.school_subjects,
        activityTemplates: state.data.staticData?.activity_templates,
        deleteCommonActivityTodoRequest:
            state.api.deleteCommonActivityTodo?.request,
        getSessionsRequest: state.api.getLiveSession?.request,
        getSessionV2Request: state.api.getLiveSessionV2?.request,
        getCallV2Request: state.api.getCallV2?.request,
        getCallRequest: state.api.getCall?.request,
        lowerAllHandsRequest: state.api.lowerAllHands?.request,
        lowerHandsRequest: state.api.lowerHands?.request,
        lowerHandsV2Request: state.api.lowerHandsV2?.request,
        lowerHandsRequestUserIds: state.api.lowerHands?.data?.user_ids,
        lowerHandsV2RequestUserIds: state.api.lowerHandsV2?.data?.user_ids,
        setSoundModeRequest: state.api.setSoundMode?.request,
        setSoundModeV2Request: state.api.setSoundModeV2?.request,
        setSoundModeRequestUserIds: state.api.setSoundMode?.data?.user_ids,
        setSoundModeV2RequestUserIds: state.api.setSoundModeV2?.data?.user_ids,
        isLive: state.liveMode.isLiveModeEnabled,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
        todayLiveSessionLogs: state.liveMode?.todayLiveSessionLogs,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    addPhoneRinging,
    removePhoneRinging,
    setPhoneRinging,
    resetPhoneRinging,
    setCallPortal,
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentsList)
